module.exports = __webpack_public_path__ + "img/elf.c6d5c344.svg";